@let hasContent = hasContent$ | async;
<i
    [raskPopover]="template"
    [disablePopover]="popoverDisabled && !hasContent"
    [closeDelay]="300"
    [triggers]="popoverTriggers"
    container="body"
    popoverClass="rask-icon-popover {{popoverClass}}"
    [class]="icon"
    #ngbPopover="raskPopover"
    (click)="onOpen(ngbPopover)"
    [autoClose]="autoClose"
    [placement]="placement"
    [ngClass]="{ 'clickable': clickToOpen === true }">
</i>

<ng-template #template>
    <span style="white-space: pre-line">{{text}}</span>
    <ng-content></ng-content>
</ng-template>

<div #templateResult style="display: none;">
    <ng-container *ngTemplateOutlet="template"></ng-container>
</div>